function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M3.255 19.675h.053c1.7-.076 3.286-.873 4.35-2.188C8.718 18.8 10.3 19.598 12 19.675c1.702-.072 3.289-.87 4.35-2.188 1.064 1.315 2.649 2.112 4.35 2.188h.053l2.061-7.3c.085-.284.06-.588-.068-.855-.131-.262-.368-.457-.652-.54l-1.386-.487V5.472c0-1.193-.97-2.165-2.175-2.182h-3.26V0H8.742v3.29H5.483c-1.207.017-2.176.989-2.175 2.182v5.021l-1.41.465c-.282.085-.518.28-.652.54-.13.267-.15.572-.06.854l2.069 7.323zM5.475 5.54h13.05v4.302L12 7.713 5.475 9.84V5.54zm10.852 14.713c1.26.936 2.783 1.46 4.358 1.5l2.19-.016v2.249H20.7c-1.52-.002-3.016-.372-4.358-1.08-2.715 1.425-5.969 1.425-8.684 0C6.316 23.616 4.82 23.99 3.3 24H1.125v-2.249h2.16c1.575-.04 3.098-.563 4.357-1.499 2.578 1.897 6.108 1.897 8.685 0z",
  clipRule: "evenodd"
});

var SvgShipFront = function SvgShipFront(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShipFront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ship-front.60e4bd2d.svg";
export { ForwardRef as ReactComponent };